import { observer } from 'mobx-react-lite'
import React from 'react'
import { GreetingAudioBlockEditContent } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/blocks/GreetingAudioBlock'
import styles from './styles.module.scss'
import { type PlayAudioStore } from '../../store/PlayAudioStore'

type IActionEditContentProps = {
  store: PlayAudioStore
}
export const PlayAudioActionEditContent = observer(({ store }: IActionEditContentProps) => {
  const { greetingAudioBlockStore } = store

  return (
    <div className={styles.wrap}>
      <GreetingAudioBlockEditContent labelText={'Audio file'} store={greetingAudioBlockStore} />
    </div>
  )
})
